export const getRandomColor = (initials = '--') => {
  if(!initials){
    initials = '--';
  }
  const firstLetter = initials.charAt(0).toLowerCase();
  const secondLetter = initials.charAt(1).toLowerCase();
  const firstLetterAsciiCode = firstLetter.charCodeAt(0);
  const secondLetterAsciiCode = secondLetter.charCodeAt(0);

  const colorNum =
    firstLetterAsciiCode.toString() + secondLetterAsciiCode.toString() + '200';

  const num = Math.round(0xffffff * parseInt(colorNum));

  const r = (num >> 16) & 250;
  const g = (num >> 8) & 180;
  const b = num & 180;


  return {
    color: 'rgb(' + r + ', ' + g + ', ' + b + ')',
    'background-color': 'rgb(' + r + ', ' + g + ', ' + b + ', 0.1)',
  };
};
